import React, { Component } from 'react'
import { Row, Col, Form, Input, Select, Button, Spin, Icon, Modal } from 'antd'
import { app } from '../../app'
import { getStencilList, sendMessages, getRule } from './message_api'
import PlayerSelector from '../../components/PlayerSelector2'

const FormItem = Form.Item

class MSend extends Component {
    constructor (props) {
        super(props)
        this.state = {
            stencil_loading: true,
            stencilList: [],
            stencilInfo: {}
        }
    }

    async componentDidMount () {
        this._isMounted = true
        const stencilList = await getStencilList()
        await this.setData({ stencilList, stencil_loading: false })
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 提交表单
     * @param e
     */
    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let user = {}
                if (values.the_way === '0') {
                    if (!this.pSelector) {
                        app.alert('请选择发布对象！', 'warn')
                        return false
                    }
                    user = this.pSelector.getValue()
                }
                Modal.confirm({
                    title: '温馨提示',
                    content: '确定发送吗？',
                    centered: true,
                    onOk: async () => {
                        await this.setData({ send_loading: true })
                        const { team } = this.props, { stencilInfo } = this.state
                        let content_json = {}
                        if (stencilInfo.variable) {
                            for (let i = 0; i < stencilInfo.variable.length; i++) {
                                if (stencilInfo.variable[i]) {
                                    content_json[stencilInfo.variable[i]] = values[stencilInfo.variable[i]]
                                }
                            }
                            content_json = JSON.stringify(content_json)
                        }
                        const params = {
                            ...user,
                            content_json,
                            type: team.type,
                            object_name: team.key,
                            the_way: values.the_way,
                            // content: values.join_result_content,
                            template_code: stencilInfo.template_code,
                        }
                        if (values.the_way === '1') {
                            params.mobile = values.mobile.join(',')
                        }
                        const flag = await sendMessages(params)
                        flag && this.props.changeSub('4')
                        await this.setData({ send_loading: false })
                    }
                })
            }
        })
    }

    /**
     * 模板变更
     * @param value
     * @returns {Promise<void>}
     */
    handleStencilChange = async (value) => {
        const { stencilInfo } = this.state, variable = stencilInfo.variable || []
        const formData = {}
        for (let i = 0; i < variable.length; i++) {
            formData[variable[i]] = ''
        }
        variable.length && this.props.form.setFields(formData)
        await this.setData({ stencilInfo: { ...this.state.stencilList[value] } })
    }

    /**
     * 自定义手机号选择
     */
    handlePhoneValidator = (rule, value, callback) => {
        // const reg = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
        const reg = /^[0-9]{11}$/
        for (let i = 0; i < value.length; i++) {
            if (!reg.test(value[i])) {
                callback(`号码【${value[i]}】非正确号码！`)
                return
            }
        }
        callback()
    }

    /**
     * 显示计算规则
     **/
    handleShowRule = async () => {
        let { rule_content } = this.state
        if (!rule_content) {
            app.alert('正在加载', 'loading', '45%', 0)
            rule_content = (await getRule()).content
            await this.setData({ rule_content })
            app.alertDestroy()
        }
        Modal.info({
            title: '短信计算规则',
            content: (
                <div style={{height: '80vh', overflowY: 'auto'}} dangerouslySetInnerHTML={{ __html: rule_content }}/>
            ),
            width: 700,
            centered: true
        })
    }

    render () {
        const { getFieldDecorator, getFieldsValue } = this.props.form,
            { stencilList, stencil_loading, stencilInfo, send_loading } = this.state,
            formItemLayout = {
                labelCol: { span: 4 },
                wrapperCol: { span: 10 },
            }, formItemLayout_param = {
                labelCol: { span: 6 },
                wrapperCol: { span: 18 },
            }, formData = getFieldsValue()
        let preview_text = '', varcount = 0, pt_isnull = true

        console.log(stencilInfo)
        if (stencilInfo.template_content) {
            preview_text = stencilInfo.template_content.replace(/\$\{([a-z|A-Z|0-9|_|\$]+)\}/g, (k) => {
                let key = k.substring(2, k.length - 1)
                if (formData[key]) {
                    pt_isnull = false
                    return formData[key]
                } else {
                    varcount += k.length
                    return k
                }
            })
            console.log(preview_text)
            preview_text = `【${stencilInfo.sign_name}】` + preview_text
            console.log(preview_text)

        }

        let pt_count = preview_text.length - varcount, msg_count = 1
        if (pt_count > 70) {
            let mcc = pt_count % 70
            if (mcc !== 0) {
                msg_count = parseInt(pt_count / 70) + 1
            } else {
                msg_count = parseInt(pt_count / 70)
            }
        }
        return (
            <div className="message-send-page">
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <FormItem label="短信模板">
                        {getFieldDecorator('template_code', {
                            rules: [
                                {
                                    required: true,
                                    message: '请选择发送短信的模板',
                                }
                            ],
                        })(
                            <Select style={{ width: 360 }} placeholder="请选择短信模板" onChange={this.handleStencilChange}
                                    notFoundContent={stencil_loading ? (<Spin size="small"/>) : null}>
                                {
                                    stencilList.map((s, si) => (
                                        <Select.Option key={s.id} value={si}>{s.name}（{s.template_code}）</Select.Option>
                                    ))
                                }
                            </Select>
                        )}
                    </FormItem>
                    {
                        stencilInfo.variable && stencilInfo.variable.length ? (
                            <Row>
                                <Col span={formItemLayout.labelCol.span} className="ant-form-item-label">
                                    <label className="ant-form-item-required">自定义内容</label>
                                </Col>
                                <Col span={formItemLayout.wrapperCol.span}>
                                    <div style={{ width: 360, marginBottom: 18 }}>
                                        {
                                            stencilInfo.variable.map(v => (
                                                <FormItem required={false} key={v}
                                                          style={{ marginBottom: 6 }} 
                                                          {...formItemLayout_param}
                                                          label={v}>
                                                    {getFieldDecorator(v, {
                                                        rules: [
                                                            { required: true, message: '请输入对应内容' }
                                                        ],
                                                        initialValue: ''
                                                    })(
                                                        <Input className="es-input" placeholder="请输入定义内容，限20字以内"
                                                               maxLength={20}
                                                               suffix={
                                                                   <span>{formData[v] ? formData[v].length : 0}/20</span>
                                                               }/>
                                                    )}
                                                </FormItem>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                        ) : null
                    }
                    <FormItem label="接收类型">
                        {getFieldDecorator('the_way', {
                            rules: [
                                {
                                    required: true,
                                    message: '请选择接收类型',
                                }
                            ],
                        })(
                            <Select style={{ width: 360 }} placeholder="请选择接收类型">
                                <Select.Option value="0">内部队员</Select.Option>
                                <Select.Option value="1">自定义号码</Select.Option>
                            </Select>
                        )}
                    </FormItem>
                    {
                        formData.the_way === '0' ? (
                            <FormItem required={true} label="接收队员" labelCol={{ span: 4 }} wrapperCol={{ span: 12 }}>
                                <PlayerSelector grade={this.props.team} onRef={(ref) => {
                                    this.pSelector = ref
                                }}/>
                            </FormItem>
                        ) : (formData.the_way === '1' ? (
                            <FormItem label="接收号码">
                                {getFieldDecorator('mobile', {
                                    rules: [
                                        {
                                            required: true,
                                            type: 'array',
                                            message: '请输入接收号码 ',
                                        }, {
                                            validator: this.handlePhoneValidator
                                        }
                                    ],
                                })(
                                    <Select placeholder="请输入接收号码，并按回车(Enter)键确认" mode="tags" style={{ width: '100%' }}/>
                                )}
                                {/*<Popover content={<div>内容</div>}>*/}
                                {/*<span className="m-link ant-form-text">*/}
                                {/*<Icon type="info-circle" style={{marginRight: 6}}/>*/}
                                {/*接收手机规则*/}
                                {/*</span>*/}
                                {/*</Popover>*/}
                            </FormItem>
                        ) : null)
                    }
                    {/*{getFieldDecorator('join_result_content', { initialValue: preview_text })(*/}
                    {/*<Input hidden/>*/}
                    {/*)}*/}
                    <Row>
                        <Col span={10} offset={4}>
                            <div style={{ width: 360 }}>
                                <Button type="primary" htmlType="submit" loading={send_loading} block>发送短信</Button>
                            </div>
                            <p style={{color: 'red', margin: '15px 0'}}>注：变量内容不允许含有限制发送的内容，例如变量中不允许透传URL或敏感信息。</p>
                        </Col>
                    </Row>
                </Form>
                <div className="sx-phone-x">
                    <div className="ex-mask"/>
                    <div className="ex-head">
                        <div className="xh-1"/>
                        <div className="xh-2"/>
                    </div>
                    <div className="ex-body">
                        <div className="xb-content">
                            <div className="bc-msg">{preview_text}</div>
                            {
                                preview_text ? (
                                    <div className="bc-zhu">
                                        <div>计费说明：当前内容字数为<b>{pt_count}</b>{pt_isnull ? '(不含变量)' : ''}，按照<b>{msg_count}</b>条短信发送并计费。
                                        </div>
                                        <div className="m-link" onClick={() => this.handleShowRule()}>查看短信计算规则</div>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                    <div className="ex-footer">
                        <div className="xf-1"/>
                    </div>
                    <div className="ex-info">
                        <Icon type="info-circle"/>
                        <div>此功能仅作为内容预览，具体情况以实际发送为准</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Form.create()(MSend)



// WEBPACK FOOTER //
// ./src/routes/message/MSend.jsx